module.exports = __webpack_public_path__ + "img/step-active.63069d0b.svg";